module.exports = __webpack_public_path__ + "img/vue-antd-logo.8a4cb1c7.jpeg";